import { CollectionsContext, CollectionsProvider } from './collections-context';

export { CollectionsContext, CollectionsProvider };

export default CollectionsContext;
